export function parseTimeToMs(timeString: string): number {
    if (typeof timeString !== 'string') {
        return 0
    }

    const match = timeString.trim().match(/^(\d*\.?\d+)(ms|s)$/)

    if (!match) {
        return 0
    }

    const value = Number.parseFloat(match[1])
    const unit = match[2]

    if (unit === 'ms') {
        return Math.round(value)
    } else if (unit === 's') {
        return Math.round(value * 1000)
    }

    return 0
}
